import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import ReactTable from 'react-table'
import { Field } from 'redux-form'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getCompanies, getCountry, getBankKeys, getBPGroups, 
  getIndustries, getBusinessPartners, getBankBranch } from 'ducks/options'
import { GeneralInformationContainer, SubDetailContainer, TableData } from './styled'
import { options } from '../../AttributeData'
import { BankAccountForm, CompanyForm, EmailAndTelForm, LoadBPForm, BlockForm } from '..'
import { Button, Segment, Modal, Header, Icon } from 'semantic-ui-react'
import { columnUser, columnBank, columnSalePerson, columnAuthorizedDirector } from '../../AttributeData'
import { getAddress } from 'ducks/address'
import { isNullOrEmpty } from 'core/utilities'
import { showConfirmModal } from 'ducks/app'
import { getBPCompanies } from 'ducks/vendorMaintenance'
import * as stylesV from 'variables/styles'
import { 
  typeOfConsultant,
  typeOfContractorSubContractor,
  typeOfDesigner,
  typeOfOther,
  typeOfSupplierDealeFactory
} from './data'

// import r from 'reactotron-react-js'

const GeneralInformation = (props) => {
  const { valueForm, companies, countries, change, address, bankKeys, bankBranch,
    businessPartnerGroups, industries, businessPartners, showConfirmModal, vendorCompanies,
    isDisplay=false } = props
  const vendorUsers = valueForm.vendorUsers ? valueForm.vendorUsers : []
  const vendorAuthorizedDirector = valueForm.vendorAuthorizedDirector ? valueForm.vendorAuthorizedDirector : []
  const vendorSalePerson = valueForm.vendorSalePerson ? valueForm.vendorSalePerson : []
  const vendorBanks = valueForm.vendorBanks ? valueForm.vendorBanks : []
  const canEditVendorData = !isNullOrEmpty(valueForm.vendorType)

  const [showGeneralInfo, setShowGeneralInfo] = useState(true)
  const [showUserForm, setShowUserForm] = useState(false)
  const [userData, setUserData] = useState(undefined)
  const [showBankForm, setShowBankForm] = useState(false)
  const [bankData, setBankData] = useState(undefined)
  const [showCompanyForm, setShowCompanyForm] = useState(false)
  const [companyData, setCompanyData] = useState(undefined)
  const [showLoadVendorForm, setShowLoadVendorForm] = useState(false)
  const [sapAddress, setSapAddress] = useState('')

  const [showWarningModal, setShowWarningModal] = useState(false)
  const [warningMessage, setWarningMessage] = useState('')
  
  useEffect(() => {
    if (!countries.data.length && !countries.loading) {
      props.getCountry()
    }

    if (!companies.data.length && !companies.loading) {
      props.getCompanies()
    }

    if (!address.data.length && !address.loading) {
      props.getAddress()
    }

    if (!bankKeys.data.length && !bankKeys.loading) {
      props.getBankKeys()
    }

    if (!businessPartnerGroups.data.length && !businessPartnerGroups.loading) {
      props.getBPGroups()
    }

    if (!industries.data.length && !industries.loading) {
      props.getIndustries()
    }

    if (!businessPartners.data.length && !businessPartners.loading) {
      props.getBusinessPartners()
    }
  }, [])

  useEffect(() => {
    if (!vendorCompanies.data.length && !vendorCompanies.loading && valueForm.vendorCode) {
      props.getBPCompanies(valueForm.vendorCode)
    }
  }, [valueForm.vendorCode])

  const provinceOptions = address.data.map(a => ({ value: lower(a.nameTh), text: a.nameTh }))

  const businessPartnerGroupOptions = () => {
    let mainDeptCode = localStorage.getItem('mainDeptCode') || ''

    if (mainDeptCode !== 'GRF') {
      return businessPartnerGroups.data.filter(g => g.value !== 'ZRPT')
    } else {
      return businessPartnerGroups.data
    }
  }

  const onSubmitVendorUser = (data, isNew, oldData) => {
    if (isNew) {
      change('vendorUsers', [...vendorUsers, data])
    } else {
      const index = vendorUsers.findIndex(u => u.email === oldData.email)
      vendorUsers[index] = data
      change('vendorUsers', [...vendorUsers])
    }
  }

  const showModalEditUser = (userIndex) => {
    setUserData(vendorUsers[userIndex])
    setShowUserForm(true)
  }

  const onDeleteUser = (userIndex) => {
    var clone = [...(valueForm.vendorUsers || [])]
    clone.splice(userIndex, 1)
    change('vendorUsers', [...clone])
  }

  const onSubmitVendorBank = (data, isNew, oldData) => {
    if (isNew) {
      change('vendorBanks', [...vendorBanks, data])
    } else {
      const { index } = data
      if (index !== null && index !== undefined) {
        vendorBanks[index] = data
      } else {
        const index = vendorBanks.findIndex(b => b.accountNumber === oldData.accountNumber)
        vendorBanks[index] = data
      }
      
      change('vendorBanks', [...vendorBanks])
    }
  }

  const showModalEditBank = (userIndex) => {
    setBankData({ ...vendorBanks[userIndex], index: userIndex })
    setShowBankForm(true)
  }

  const onDeleteBank = (userIndex) => {
    var clone = [...(valueForm.vendorBanks || [])]
    clone.splice(userIndex, 1)
    change(`vendorBanks`, [...clone])
  }

  const distinctOptions = () => {
    const province = address.data.find(d => d.nameTh === valueForm.province)

    if (province) {
      return province.districts.map(a => ({ value: lower(a.nameTh), text: a.nameTh }))
    }

    return ([])
  }

  const subDistinctOptions = () => {
    const province = address.data.find(d => d.nameTh === valueForm.province)

    if (province) {
      const district = province.districts.find(d => d.nameTh === valueForm.district)
      if (district) {
        return district.subDistricts.map(a => ({ value: lower(a.nameTh), text: a.nameTh, code: a.zipCode }))
      }
    } 

    return ([])
  }

  const onChangePurpose = (value) => {
    change('vendorCode', '')
    change('companyCode', '')
    change('accountGroup', '')
    change('vendorType', '')
    change('vendorName1', '')
    change('vendorName2', '')
    change('vendorName3', '')
    change('vendorName4', '')
    change('searchName', '')
    change('industry', '')
    change('standardIndustry', true)
    change('taxId', '')
    change('country', '')
    change('province', '')
    change('district', '')
    change('subDistrict', '')
    change('postalCode', '')
    change('houseNumber', '')
    change('buildingOrRoomNo', '')
    change('street', '')
    change('vendorUsers', [])
    change('vendorBanks', [])

    if (value === 'change' || value === 'block') {
      change('paymentMethod', [])
      change('paymentTypeTransfer', false)
      change('paymentTypeCheque', false)
      change('paymentTypeTtlc', false)
    }
  }

  const onChangeAccountGroup = (value) => {
    if (['ZDOV', 'ZFOV', 'ZRPT', 'ZOTV'].includes(value)) {
      change('usePurchasingView', true)
    } else {
      change('usePurchasingView', false)
      change('purchasingOrg', '')
      change('orderCurrency', '')
      change('paymentTerms', '')
      change('salePerson', '')
      change('salePersonTelephone', '')
      change('incoterm', '')
      change('incotermsLocation', '')
      change('grBasedInvoiceVerification', false)
    }

    if (['ZDOV', 'ZRPT', 'ZOTV'].includes(value)) {
      change('grBasedInvoiceVerification', true)
    } else {
      change('grBasedInvoiceVerification', false)
    }

    if (value === 'ZFIN' || value === 'ZRPT') {
      change('vendorType', 'company')
    }

    if (value === 'ZEMP') {
      change('vendorType', 'personal')
    }

    // Default Accounting Information
    if (value ==='ZDOV') {
      change('planningGroup', 'V1')
      change('reconciliationAccount', '23000010')
      change('sortKey', '002')
    } else if (value ==='ZFOV') {
      change('planningGroup', 'V2')
      change('reconciliationAccount', '26400000')
      change('sortKey', '002')
    } else if (value ==='ZRPT') {
      change('planningGroup', 'V3')
      change('reconciliationAccount', '23001010')
      change('sortKey', '002')
    } else {
      change('planningGroup', 'V1')
      change('reconciliationAccount', '26400000')
      change('sortKey', '002')
    }
  }

  const getBoolValue = (value, defaultValue) => {
    return (value !== undefined && value !== null && value !== '') ? value : defaultValue
  }

  const onLoadBusinessPartnerSuccess = (data) => {
    setShowLoadVendorForm(false)

    // var startTime = new Date()
    change('vendorCode', data.vendorCode || '')
    change('companyCode', data.companyCode || '')
    change('accountGroup', data.accountGroup || '')
    change('vendorType', data.vendorType || '')
    change('vendorName1', data.vendorName1 || '')
    change('vendorName2', data.vendorName2 || '')
    change('vendorName3', data.vendorName3 || '')
    change('vendorName4', data.vendorName4 || '')
    change('searchName', data.searchName || '')
    change('industry', data.industry || '')
    change('standardIndustry', getBoolValue(data.standardIndustry, true))
    change('taxId', data.taxId || '')
    change('country', data.country || '')
    change('province', data.province || '')
    change('district', data.district || '')
    change('subDistrict', data.subDistrict || '')
    change('postalCode', data.postalCode || '')
    change('houseNumber', data.houseNumber || '')
    change('buildingOrRoomNo', data.buildingOrRoomNo || '')
    change('street', data.street || '')
    change('vendorUsers', [...(data.users || [])])
    change('vendorBanks', [...(data.banks || [])])

    change('branchCode', '')
    change('branchDescription', '')

    var address = data.houseNumber ? data.houseNumber : '' 
    address = address + (data.buildingOrRoomNo ? ` ${data.buildingOrRoomNo}` : '')
    address = address + (data.street ? ` ${data.street}` : '')
    address = address + (data.subDistrict ? ` ${data.subDistrict}` : '')
    address = address + (data.district ? ` ${data.district}` : '')
    address = address + (data.province ? ` ${data.province}` : '')
    address = address + (data.postalCode ? ` ${data.postalCode}` : '')
    address = address.replace('  ', ' ').trim()
    setSapAddress(address)

    // var endTime = new Date()
    // var then = moment(startTime)
    // var now = moment(endTime)
    // var timeDifference = now.diff(then, 'seconds', true);
    // r.log(`Time difference - ${timeDifference} seconds`) 
  }

  const onLoadBusinessPartnerWarning = (message) => {
    setWarningMessage(message)
    setShowWarningModal(true)
  }

  const renderVendorInputWithLoadButton = (props) => {
    return (
      <div style={{ display: 'flex', flex: 1 }}>
        {
          valueForm.vendorCode ? 
            <FieldInput {...props} /> : null
        }
        {
          isDisplay || valueForm.status === 5 ? null :
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button 
              color='blue'
              content={valueForm.vendorCode ? 'Change' : 'Load Business Partner'}
              type='button'
              style={{marginRight: '15px' }}
              onClick={() => setShowLoadVendorForm(true)}
            />
          </div>
        }
      </div>
    )
  }

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return !isDisplay
    }
  }

  const editable = () => {
    return editableForm() && (valueForm.purpose === 'create' || valueForm.purpose === 'change')
  }

  const beforeCountryChange = (valueForm) => (props) => {
    const checkAddressValueIsNotEmpty = () => {
      var isNotEmpty = false
      const { province, district, subDistrict, postalCode, houseNumber, buildingOrRoomNo, street } = valueForm
      
      if (province !== undefined && province !== '' && province !== null) isNotEmpty = true
      if (district !== undefined && district !== '' && district !== null) isNotEmpty = true
      if (subDistrict !== undefined && subDistrict !== '' && subDistrict !== null) isNotEmpty = true
      if (postalCode !== undefined && postalCode !== '' && postalCode !== null) isNotEmpty = true
      if (houseNumber !== undefined && houseNumber !== '' && houseNumber !== null) isNotEmpty = true
      if (buildingOrRoomNo !== undefined && buildingOrRoomNo !== '' && buildingOrRoomNo !== null) isNotEmpty = true
      if (street !== undefined && street !== '' && street !== null) isNotEmpty = true

      return isNotEmpty
    }

    if (valueForm.country && valueForm.country !== props.value && checkAddressValueIsNotEmpty()) {
      showConfirmModal(
        true, 
        {
          header: 'Are you sure you want to change the country?',
          message: 
            <React.Fragment>
              {'The address information will be deleted immediately.'}
            </React.Fragment>,
          btnConfirmText: 'Yes',
          onClickConfirm: () => {
            props.onChange()
            if (props.specialOnChange) props.specialOnChange()
            change('province', '')
            change('district', '')
            change('subDistrict', '')
            change('postalCode', '')
            change('houseNumber', '')
            change('buildingOrRoomNo', '')
            change('street', '')
          },
          btnCancelText: 'No',
          onClickCancel: () => { 
            props.clearSearchText()
          }
        }
      )
    } else {
      props.onChange()
      if (props.specialOnChange) props.specialOnChange()
    }
  }

  const companyFieldIsEditable = () => {
    if (valueForm.purpose === 'create') {
      return editableForm()
    } else if (valueForm.purpose === 'change') {
      if (valueForm.vendorCode) {
        if (vendorCompanies.data.length === 0) {
          return editableForm()
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  }

  const setTypeOfBusiness = () => {
    let result = []
    if(valueForm&&valueForm.typeOfVendor){
      if(valueForm.typeOfVendor.Consultant){
        result.push(...typeOfConsultant)
      }
      if(valueForm.typeOfVendor.Designer){
        result.push(...typeOfDesigner)
      }
      if(valueForm.typeOfVendor.ContractorSubContractor){
        result.push(...typeOfContractorSubContractor)
      }
      if(valueForm.typeOfVendor.SupplierDealer||valueForm.typeOfVendor.Factory){
        result.push(...typeOfSupplierDealeFactory)
      }
      if(valueForm.typeOfVendor.Other){
        result.push(...typeOfOther)
      }
    }
    return result
  }

  const setYearOptions = () => {
    let d = new Date();
    let ny = d.getFullYear();
    if(ny<2500) ny=ny+543
    const result = []
    for(let i=0;i<20;i++){
        let y = --ny
        result.push({key:i,text:y,value:y})
    }
    return result
  }

  return (
    <React.Fragment>
      <Card style={{ marginTop: '10px' }}>
        <CardHeader 
          title='General Information'
          action={
            <IconButton aria-label='Expand' onClick={() => setShowGeneralInfo(!showGeneralInfo) }>
              {showGeneralInfo ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          }
        />
        <Collapse in={showGeneralInfo}>
          <CardContent>
            <GeneralInformationContainer>
              <div className='rowFields'>
                <Field 
                  name='purpose'
                  label='Purpose'
                  require
                  type={type.select}
                  editable={
                    editableForm() && (valueForm.status === undefined)
                  }
                  options={options.purpose}
                  specialOnChange={(value) => onChangePurpose(value)}
                  component={FieldInput} />
                {
                  !valueForm.purpose || valueForm.purpose === 'create' ?
                    <Field 
                      name='vendorCode'
                      label='Business Partner Number'
                      editable={valueForm.accountGroup === 'ZEMP' && editableForm()} 
                      require={valueForm.accountGroup === 'ZEMP'}
                      type={type.text} 
                      component={FieldInput} 
                    /> :
                    <Field 
                      name='vendorCode'
                      label='Business Partner Number'
                      require
                      editable={false}
                      containerStyle={{ marginRight: '10px' }}
                      type={type.text}
                      component={renderVendorInputWithLoadButton} 
                    />
                }
              </div>
              <div className='rowFields'>
                <Field 
                  name='accountGroup' 
                  label='Account Group'
                  require
                  // editable={
                  //   valueForm.purpose === 'create' && 
                  //   editableForm() &&
                  //   (valueForm.status === undefined || valueForm.status === 0)
                  // }
                  type={type.select}
                  options={businessPartnerGroupOptions()}
                  specialOnChange={(value) => onChangeAccountGroup(value)}
                  component={FieldInput} />
                {
                  valueForm.purpose !== 'copy' ?
                    <Field 
                      name='companyCode' 
                      label='Company' 
                      require 
                      // editable={companyFieldIsEditable()}
                      loading={companies.loading} 
                      options={companies.data} 
                      specialOnChange={(value) => {
                        var company = companies.data.find(c => c.value === value)
                        if (company) {
                          var companyName = company.text.replace(`${value} : `, '')
                          change('companyName', companyName)
                        }
                      }}
                      type={type.select} 
                      component={FieldInput}
                    />
                    : <Field name='empty' label='' require type={type.empty} component={FieldInput} />
                }
              </div>
              {
                valueForm.purpose === 'copy' ?
                  <div className='rowFields'>
                    <Button 
                      color='blue'
                      content='Add Company'
                      type='button'
                      style={{ flex: 1 }}
                      onClick={() => setShowCompanyForm(true)}
                    />
                    <Field name='empty' label='' require type={type.empty} component={FieldInput} />
                  </div>
                  : null
              }
              {
                valueForm.purpose === 'block' && valueForm.vendorCode ? 
                  <BlockForm change={change} />: null
              }
              <SubDetailContainer>
                <div className='subTitle'>Name and Address</div>
                <div className='rowFields'>
                  <Field 
                    name='vendorType' 
                    label='Type' 
                    require 
                    editable={editable() && valueForm.accountGroup !== 'ZFIN' && valueForm.accountGroup !== 'ZEMP' && valueForm.accountGroup !== 'ZRPT'}
                    options={options.vendorType} 
                    type={type.radio} 
                    component={FieldInput} 
                  />
                </div>
                <div className='rowFields'>
                  <Field 
                    name='vendorName1' 
                    label='Vendor Name' 
                    require 
                    placeHolder={
                      valueForm.vendorType === 'personal' ?
                        'กรุณาระบุคำนำหน้า ชื่อ และนามสกุล ตามบัตรประชาชนหรือหนังสือเดินทาง เช่น น.ส. อภิศรา รุ่งเรือง' :
                        'กรุณาระบุคำนำหน้าบริษัทและชื่อบริษัท บจก. , หจก. , บมจ. เช่น บจก. ทีเอชเอส'
                    }
                    editable={canEditVendorData && editable()} 
                    type={type.text} 
                    component={FieldInput} 
                  />
                  <Field 
                    name='searchName' 
                    label='Search Vendor Name' 
                    require 
                    placeHolder='กรุณาระบุคำสำหรับใช้ค้นหาชื่อ'
                    // editable={canEditVendorData && editable()}
                    type={type.text} 
                    component={FieldInput} 
                  />
                </div>
                <div className='rowFields'>
                  <Field 
                    name='vendorName2' 
                    label='' 
                    type={type.text} 
                    placeHolder='สำรองชื่อ Vendor Name'
                    editable={canEditVendorData && editable()} 
                    component={FieldInput} 
                  />
                  <Field name='empty' label='' type={type.empty} component={FieldInput} />
                </div>
                <div className='rowFields'>
                  <Field 
                    name='vendorName3' 
                    label='' 
                    type={type.text} 
                    placeHolder='สำรองชื่อ Vendor Name'
                    editable={canEditVendorData && editable()} 
                    component={FieldInput} 
                  />
                  <Field name='empty' label='' type={type.empty} component={FieldInput} />
                </div>
                <div className='rowFields'>
                  <Field 
                    name='vendorName4' 
                    label='' 
                    type={type.text} 
                    placeHolder='สำรองชื่อ Vendor Name'
                    editable={canEditVendorData && editable()} 
                    component={FieldInput} 
                  />
                  <Field name='empty' label='' type={type.empty} component={FieldInput} />
                </div>
                <div className='rowFields'>
                  <Field 
                    name='industry' 
                    label='Industry' 
                    type={type.select}
                    require
                    loading={industries.loading} 
                    options={industries.data} 
                    editable={canEditVendorData && editable()} 
                    component={FieldInput} />
                  <Field 
                    name='standardIndustry' 
                    label='Standard Industry' 
                    type={type.checkbox} 
                    editable={false} 
                    fieldInputStyle={{ justifyContent: 'center' }} 
                    component={FieldInput} 
                  />
                </div> 
                <div className='rowFields'>
                  <Field 
                    name='taxId' 
                    label={valueForm.vendorType === 'personal' ? 'Tax ID Personal/Passport No.' : 'Tax ID Legal Entity/Company'} 
                    require={valueForm.accountGroup !== 'ZFOV'}
                    editable={canEditVendorData && editable()} 
                    type={type.text} 
                    component={FieldInput} 
                  />
                  <Field name='empty' label='' type={type.empty} component={FieldInput} />
                </div> 
                <div className='rowFields'>
                  <Field 
                    name='country' 
                    label='Country' 
                    require
                    type={type.select} 
                    options={countries.data} 
                    loading={countries.loading} 
                    component={FieldInput}
                    editable={canEditVendorData && editable()}
                    beforeOnChange={beforeCountryChange(valueForm)}
                    specialOnChange={(value) => {
                      if (value === 'TH') {
                        change('province', '')
                        change('district', '')
                        change('subDistrict', '')
                        change('postalCode', '')
                      }
                    }}
                  />
                  <Field 
                    name='province' 
                    label='Province/City' 
                    require
                    type={valueForm.country === 'TH' ? type.select : type.text} 
                    options={provinceOptions} 
                    loading={valueForm.country === 'TH' ? address.loading : false} 
                    component={FieldInput}
                    editable={canEditVendorData && editable()}
                    specialOnChange={() => {
                      if (valueForm.country === 'TH') {
                        change('district', '')
                        change('subDistrict', '')
                        change('postalCode', '')
                      }
                    }}
                  />
                </div>
                <div className='rowFields'>
                  <Field 
                    name='district' 
                    label='District' 
                    require
                    type={valueForm.country === 'TH' ? type.select : type.text} 
                    options={distinctOptions()}
                    specialOnChange={() => {
                      if (valueForm.country === 'TH') {
                        change('subDistrict', '')
                        change('postalCode', '')
                      }
                    }}
                    editable={canEditVendorData && editable()}
                    noResultsMessage={
                      valueForm.country === 'TH' &&
                      (valueForm.province === undefined || 
                        valueForm.province === '' || 
                        valueForm.province === null) ? 'Please Select Province/City before District' : undefined
                    }
                    component={FieldInput} 
                  />
                  <Field 
                    name='subDistrict' 
                    label='Sub-district' 
                    require
                    type={valueForm.country === 'TH' ? type.select : type.text} 
                    options={subDistinctOptions()} 
                    specialOnChange={(value) => {
                      if (valueForm.country === 'TH') {
                        var subDistrictOpts = subDistinctOptions()
                        var subDistrict = subDistrictOpts.find(s => s.value === value)
                        if (subDistrict) {
                          change('postalCode', `${subDistrict.code}` || '')
                        }
                      }
                    }}
                    editable={canEditVendorData && editable()}
                    noResultsMessage={
                      valueForm.country === 'TH' &&
                      (valueForm.district === undefined || 
                        valueForm.district === '' || 
                        valueForm.district === null) ? 'Please Select District before Sub-District' : undefined
                    }
                    component={FieldInput} 
                  />
                </div>
                <div className='rowFields'>
                  <Field 
                    name='houseNumber' 
                    label='House Number' 
                    require 
                    placeHolder='กรุณาระบุ เลขที่บ้าน / เลขที่อาคาร'
                    editable={canEditVendorData && editable()} 
                    type={type.text} 
                    component={FieldInput} 
                  />
                  <Field 
                    name='buildingOrRoomNo' 
                    label='Room Number/Village/Moo/Building/Floor/Street(1)' 
                    require 
                    editable={canEditVendorData && editable()} 
                    placeHolder='กรุณาระบุ เลขที่ห้อง / หมูบ้าน / อาคาร / ชั้น / ซอย / ถนน'
                    type={type.text} 
                    component={FieldInput} 
                  />
                </div>
                <div className='rowFields'>
                  <Field 
                    name='street' 
                    label='Street(2)'  
                    editable={canEditVendorData && editable()} 
                    placeHolder={isDisplay ? '' : 'กรุณาระบุ ซอย / ถนน'}
                    type={type.text} 
                    component={FieldInput} 
                  />
                  <Field 
                    name='postalCode' 
                    label='Postal Code' 
                    require 
                    editable={canEditVendorData && editable()} 
                    type={type.text} 
                    component={FieldInput} 
                  />
                </div>
                <div className='rowFields'>
                  <Field 
                    name='mobile' 
                    label='Mobile'  
                    editable={canEditVendorData && editable()} 
                    type={type.text} 
                    component={FieldInput} 
                  />
                  <Field 
                    name='telephone' 
                    label='Telephone' 
                    require 
                    editable={canEditVendorData && editable()} 
                    type={type.text} 
                    component={FieldInput} 
                  />
                </div>
                <div className='rowFields'>
                  <Field 
                    name='extension' 
                    label='Extension' 
                    require 
                    editable={canEditVendorData && editable()} 
                    type={type.text} 
                    component={FieldInput} 
                  />
                  <Field 
                    name='website' 
                    label='Website'  
                    editable={canEditVendorData && editable()} 
                    type={type.text} 
                    component={FieldInput} 
                  />
                </div>
                <div className='fieldHeader'>
                  {/* <div className='headerText'>Type of Vendor <span className='require'>*</span></div> */}
                  <Field 
                    name='typeOfVendor' 
                    label='Type of Vendor'
                    type={type.text}
                    component={FieldInput}
                    editable={canEditVendorData && editable()} 
                    className={'halfRow'}
                    dummy
                  />
                  <div className='fieldsCheckBox'>
                    <Field 
                      name='typeOfVendor.Consultant' 
                      label='Consultant'
                      type={type.checkbox}
                      component={FieldInput}
                      editable={canEditVendorData && editable()} 
                      style={{flex:'none'}}
                    />
                    <Field 
                      name='typeOfVendor.Designer' 
                      label='Designer'
                      type={type.checkbox}
                      component={FieldInput}
                      editable={canEditVendorData && editable()} 
                      style={{flex:'none'}}
                    />
                    <Field 
                      name='typeOfVendor.ContractorSubContractor' 
                      label='Contractor / Sub-Contractor'
                      type={type.checkbox}
                      component={FieldInput}
                      editable={canEditVendorData && editable()} 
                      style={{flex:'none'}}
                    />
                    <Field 
                      name='typeOfVendor.SupplierDealer' 
                      label='Supplier / Dealer'
                      type={type.checkbox}
                      component={FieldInput}
                      editable={canEditVendorData && editable()} 
                      style={{flex:'none'}}
                    />
                    <Field 
                      name='typeOfVendor.Factory' 
                      label='Factory'
                      type={type.checkbox}
                      component={FieldInput}
                      editable={canEditVendorData && editable()} 
                      style={{flex:'none'}}
                    />
                    <Field 
                      name='typeOfVendor.Other' 
                      label='Other'
                      type={type.checkbox}
                      component={FieldInput}
                      editable={canEditVendorData && editable()} 
                      style={{flex:'none'}}
                    />
                  </div>
                </div>
                <div className='rowFields'>
                  <Field 
                    name='typeOfBusiness' 
                    label='Type of Business'
                    type={type.multiSelect}
                    editable={canEditVendorData && editable()} 
                    component={FieldInput}
                    className='halfRow'
                    options={setTypeOfBusiness()}
                  />
                  {valueForm&&valueForm.typeOfBusiness&&valueForm.typeOfBusiness.includes('Other')?
                  <Field 
                    name='typeOfBusinessOther' 
                    label='Other type'
                    type={type.text}
                    component={FieldInput}
                    className={'halfRow'}
                  />:null}
                </div>
                <div className='rowFields'>
                  <Field 
                    name='totalValueOfCurrentProject' 
                    label='Total value of current projects'
                    type={type.number}
                    editable={canEditVendorData && editable()} 
                    component={FieldInput}
                  />
                  <Field 
                    name='totalValueOfCurrentProjectCurrency' 
                    label='Currency'
                    type={type.select}
                    loading={props.currencies.loading} 
                    options={props.currencies.data} 
                    editable={canEditVendorData && editable()} 
                    component={FieldInput}
                  />
                </div>
                {/* List of Dealer */}
                <div className='textHeader'>List of Dealer</div>
                <div style={{display:'flex', flexDirection:'column'}}>
                  <div style={{marginTop:'0.7rem'}}/>
                  <TableData>
                    <div style={{display:'flex'}}>
                      <div className='tbHeader' style={{flex:1}}>Dealer Name</div>
                    </div>
                    {
                      valueForm&&valueForm.listDealer&&valueForm.listDealer.map((v,i)=>{
                        return !v.deleted&&
                        <div style={{display:'flex'}}>
                          <div className='tbRow' style={{flex:1}}>
                            <Field 
                              name={`listDealer[${i}].dealerName`} 
                              type={type.text}
                              component={FieldInput}
                              placeHolder='Dealer Name'
                            />
                          </div>
                        </div>
                      })
                    }
                  </TableData>
                </div>
              </SubDetailContainer>
              <SubDetailContainer>
                <div className='subTitle'>EzProcure Registration and Communication</div>
                {
                  editable() ? 
                    <div className='rowFields'>
                      <Button 
                        color='blue'
                        content='Add Name'
                        type='button'
                        disabled={vendorUsers.length > 4}
                        style={{ flex: 1 }}
                        onClick={() => setShowUserForm(true)}
                      />
                      <div style={{ flex: 1 }} />
                    </div> : null
                }
                {
                  (valueForm.vendorUsers || []).filter(u => u.registerEzProcure === true).length === 0 
                  && (valueForm.purpose === 'create' || valueForm.purpose === 'change') ?
                  (!editable() && (
                    valueForm.notRegisterRemark === '' || 
                    valueForm.notRegisterRemark === undefined || 
                    valueForm.notRegisterRemark === null)) ? null :
                    <div className='rowFields'>
                      <Field 
                        name='notRegisterRemark'
                        label='Not Register Remark'
                        require={['ZDOV', 'ZFOV', 'ZRPT', 'ZOTV'].includes(valueForm.accountGroup)}
                        editable={editable()} 
                        type={type.textArea} 
                        placeHolder='กรุณาระบุเหตุผลที่ Vendor ไม่เข้าใช้งานระบบ EzProcure'
                        component={FieldInput} 
                      />
                    </div> : null 
                }
                {
                  vendorUsers.length ?
                    <ReactTable
                      data={vendorUsers}
                      columns={
                        columnUser({ 
                          withActions: editable(),
                          showUserModal: showModalEditUser, 
                          onDeleteUser: onDeleteUser 
                        })}
                      sortable={false}
                      pageSize={vendorUsers.length}
                      defaultPageSize={vendorUsers.length}
                      className='-striped -highlight'
                      showPagination={false}
                    /> : null
                }
              </SubDetailContainer>
              <SubDetailContainer>
                <div className='subTitle'>Authorized Director</div>
                {
                  vendorAuthorizedDirector.length ?
                    <ReactTable
                      data={vendorAuthorizedDirector}
                      columns={columnAuthorizedDirector}
                      sortable={false}
                      pageSize={vendorAuthorizedDirector.length}
                      defaultPageSize={vendorAuthorizedDirector.length}
                      className='-striped -highlight'
                      showPagination={false}
                    /> : null
                }
              </SubDetailContainer>
              <SubDetailContainer>
                <div className='subTitle'>Sales Contact Person</div>
                {
                  vendorAuthorizedDirector.length ?
                    <ReactTable
                      data={vendorSalePerson}
                      columns={columnSalePerson}
                      sortable={false}
                      pageSize={vendorSalePerson.length}
                      defaultPageSize={vendorSalePerson.length}
                      className='-striped -highlight'
                      showPagination={false}
                    /> : null
                }
              </SubDetailContainer>
              <SubDetailContainer>
                <div className='subTitle'>Payment Details</div>
                <div className='rowFields'>
                  <Field 
                    name='paymentType' 
                    label='Payment Type' 
                    type={type.labelOnly} 
                    component={FieldInput} 
                  />
                </div>
                <div className='rowFields'>
                  <Field 
                    name='paymentTypeTransfer' 
                    label='Transfer' 
                    editable={editable()}
                    type={type.checkbox} 
                    component={FieldInput} 
                  />
                  <Field 
                    name='paymentTypeCheque' 
                    label='Cheque' 
                    editable={editable()}
                    type={type.checkbox} 
                    component={FieldInput} 
                  />
                  <Field 
                    name='paymentTypeTtlc' 
                    label='T/T, L/C' 
                    editable={editable()}
                    type={type.checkbox} 
                    component={FieldInput} 
                  />
                  <Field name='empty' label='' type={type.empty} component={FieldInput} />
                  <Field name='empty' label='' type={type.empty} component={FieldInput} />
                  <Field name='empty' label='' type={type.empty} component={FieldInput} />
                </div>
                {
                  editable() ? 
                    <div className='rowFields'>
                      <Button 
                        color='blue'
                        content='Add Bank Account'
                        type='button'
                        style={{ flex: 1 }}
                        onClick={() => setShowBankForm(true)}
                      />
                      <div style={{ flex: 1 }} />
                    </div> : null
                }
                {
                  vendorBanks.length ?
                    <ReactTable
                      data={vendorBanks}
                      columns={
                        columnBank({ 
                          withActions: editable(),
                          showBankModal: showModalEditBank, 
                          onDeleteBank: onDeleteBank,
                          countryOptions: countries.data,
                          bankKeyOptions: bankKeys.data,
                          bankBranchOptions: bankBranch,
                          getBankBranch: props.getBankBranch
                        })}
                      sortable={false}
                      pageSize={vendorBanks.length}
                      defaultPageSize={vendorBanks.length}
                      className='-striped -highlight'
                      showPagination={false}
                    /> : null
                }
              </SubDetailContainer>
              <SubDetailContainer>
                <div className='subTitle'>Credit and registered capital information</div>
                <div className='rowFields'>
                  <Field 
                    name='yearOfEstablishment' 
                    label='ปีที่ก่อตั้งบริษัท (ปี)'
                    type={type.number}
                    component={FieldInput}
                    thousandSeparator={false}
                    editable={canEditVendorData && editable()} 
                  />
                  <Field 
                    name='bankLoan' 
                    label='สินเชื่อทางธนาคาร'
                    type={type.radio}
                    component={FieldInput}
                    horizontalView
                    editable={canEditVendorData && editable()} 
                    options={[
                      {
                        text:'มี',
                        value:true
                      },
                      {
                        text:'ไม่มี',
                        value:false
                      }
                    ]}
                  />
                </div>
                <div className='rowFields'>
                  <Field 
                    name='registeredCapital' 
                    label='ทุนจดทะเบียน (บาท)'
                    type={type.number}
                    component={FieldInput}
                    editable={canEditVendorData && editable()} 
                  />
                  <Field 
                    name='paidUpRegisteredCapital' 
                    label='ทุนจดทะเบียนชำระแล้ว (บาท)'
                    type={type.number}
                    component={FieldInput}
                    editable={canEditVendorData && editable()} 
                  />
                </div>
              </SubDetailContainer>
              <SubDetailContainer>
                <div className='subTitle'>Project Reference</div>
                {(valueForm&&!  valueForm.projectReference)||(valueForm&&valueForm.projectReference&&valueForm.projectReference.length==0)?
                  <div style={{display:'flex',color:stylesV.borderGray}}>
                    No data
                  </div>
                  :
                  <TableData>
                    <div style={{display:'flex'}}>
                      <div className='tbHeader' style={{flex:1}}>Project Name</div>
                    </div>
                    {
                      valueForm&&valueForm.projectReference&&valueForm.projectReference.map((v,i)=>{
                        return(
                          <div style={{display:'flex'}}>
                            <div className='tbRow' style={{flex:1}}>
                              <Field 
                                name={`projectReference[${i}].projectName`} 
                                type={type.text}
                                component={FieldInput}
                                placeHolder='Project Name'
                                editable={canEditVendorData && editable()} 
                              />
                            </div>
                          </div>
                        )
                      })
                    }
                  </TableData>
                }
              </SubDetailContainer>
              <SubDetailContainer>
                <div className='subTitle'>รายได้</div>
                {(valueForm&&!  valueForm.income)||(valueForm&&valueForm.income&&valueForm.income.length==0)?
                  <div style={{display:'flex',color:stylesV.borderGray}}>
                    No data
                  </div>
                  :
                  <TableData>
                    <div style={{display:'flex'}}>
                      <div className='tbHeader' style={{width:'10%'}}>ปี พ.ศ.</div>
                      <div className='tbHeader' style={{flex:1}}>รายได้ (ล้านบาท)</div>
                    </div>
                    {
                      valueForm&&valueForm.income&&valueForm.income.map((v,index)=>{
                        return(
                          <div style={{display:'flex'}}>
                            <div className='tbRowL' style={{width:'10%'}}>
                              <Field 
                                name={`income[${index}].year`} 
                                type={type.select}
                                component={FieldInput}
                                options={setYearOptions().filter(i=>valueForm.income.findIndex(ii=>(ii.year==i.value))<0||i.value==valueForm.income[index].year)}
                                editable={canEditVendorData && editable()} 
                                placeHolder='ปี พ.ศ.'
                              />
                            </div>
                            <div className='tbRow' style={{flex:1}}>
                              <Field 
                                name={`income[${index}].income`} 
                                type={type.number}
                                component={FieldInput}
                                placeHolder='รายได้'
                                editable={canEditVendorData && editable()} 
                                textAlignLeft
                              />
                            </div>
                          </div>
                        )
                      })
                    }
                  </TableData>
                }
              </SubDetailContainer>
              <SubDetailContainer>
                <div className='subTitle'>Current ratio อัตราส่วนทุนหมุนเวียน (เท่า)</div>
                {(valueForm&&!  valueForm.currentRatio)||(valueForm&&valueForm.currentRatio&&valueForm.currentRatio.length==0)?
                  <div style={{display:'flex',color:stylesV.borderGray}}>
                    No data
                  </div>
                  :
                  <TableData>
                    <div style={{display:'flex'}}>
                      <div className='tbHeader' style={{width:'10%'}}>ปี พ.ศ.</div>
                      <div className='tbHeader' style={{flex:1}}>จำนวน (เท่า)</div>
                    </div>
                    {
                      valueForm&&valueForm.currentRatio&&valueForm.currentRatio.map((v,index)=>{
                        return(
                          <div style={{display:'flex'}}>
                            <div className='tbRowL' style={{width:'10%'}}>
                              <Field 
                                name={`currentRatio[${index}].year`} 
                                type={type.select}
                                component={FieldInput}
                                options={setYearOptions().filter(i=>valueForm.currentRatio.findIndex(ii=>(ii.year==i.value))<0||i.value==valueForm.currentRatio[index].year)}
                                editable={canEditVendorData && editable()} 
                                placeHolder='ปี พ.ศ.'
                              />
                            </div>
                            <div className='tbRow' style={{flex:1}}>
                              <Field 
                                name={`currentRatio[${index}].ratio`} 
                                type={type.number}
                                component={FieldInput}
                                placeHolder='จำนวน'
                                editable={canEditVendorData && editable()} 
                                textAlignLeft
                              />
                            </div>
                          </div>
                        )
                      })
                    }
                  </TableData>
                }
              </SubDetailContainer>
              <SubDetailContainer>
                <div className='subTitle'>ผลตอบแทนจากกำไรสุทธิต่อรายได้รวม (%)</div>
                {(valueForm&&!  valueForm.profit)||(valueForm&&valueForm.profit&&valueForm.profit.length==0)?
                  <div style={{display:'flex',color:stylesV.borderGray}}>
                    No data
                  </div>
                  :
                  <TableData>
                    <div style={{display:'flex'}}>
                      <div className='tbHeader' style={{width:'10%'}}>ปี พ.ศ.</div>
                      <div className='tbHeader' style={{flex:1}}>กำไร (%)</div>
                    </div>
                    {
                      valueForm&&valueForm.profit&&valueForm.profit.map((v,index)=>{
                        return(
                          <div style={{display:'flex'}}>
                            <div className='tbRowL' style={{width:'10%'}}>
                              <Field 
                                name={`profit[${index}].year`} 
                                type={type.select}
                                component={FieldInput}
                                options={setYearOptions().filter(i=>valueForm.profit.findIndex(ii=>(ii.year==i.value))<0||i.value==valueForm.profit[index].year)}
                                editable={canEditVendorData && editable()} 
                                placeHolder='ปี พ.ศ.'
                              />
                            </div>
                            <div className='tbRow' style={{flex:1}}>
                              <Field 
                                name={`profit[${index}].profit`} 
                                type={type.number}
                                component={FieldInput}
                                placeHolder='กำไร(%)'
                                editable={canEditVendorData && editable()} 
                                textAlignLeft
                              />
                            </div>
                          </div>
                        )
                      })
                    }
                  </TableData>
                }
              </SubDetailContainer>
              <SubDetailContainer>
                <div className='subTitle'>ส่วนของผู้ถือหุ้น</div>
                {(valueForm&&!  valueForm.shareholder)||(valueForm&&valueForm.shareholder&&valueForm.shareholder.length==0)?
                  <div style={{display:'flex',color:stylesV.borderGray}}>
                    No data
                  </div>
                  :
                  <TableData>
                    <div style={{display:'flex'}}>
                      <div className='tbHeader' style={{width:'10%'}}>ปี พ.ศ.</div>
                      <div className='tbHeader' style={{flex:1}}>ส่วนของผู้ถือหุ้น (ล้านบาท)</div>
                    </div>
                    {
                      valueForm&&valueForm.shareholder&&valueForm.shareholder.map((v,index)=>{
                        return(
                          <div style={{display:'flex'}}>
                            <div className='tbRowL' style={{width:'10%'}}>
                              <Field 
                                name={`shareholder[${index}].year`} 
                                type={type.select}
                                component={FieldInput}
                                options={setYearOptions().filter(i=>valueForm.shareholder.findIndex(ii=>(ii.year==i.value))<0||i.value==valueForm.shareholder[index].year)}
                                editable={canEditVendorData && editable()} 
                                placeHolder='ปี พ.ศ.'
                              />
                            </div>
                            <div className='tbRow' style={{flex:1}}>
                              <Field 
                                name={`shareholder[${index}].ratio`} 
                                type={type.number}
                                component={FieldInput}
                                placeHolder='ส่วนของผู้ถือหุ้น(ล้านบาท)'
                                editable={canEditVendorData && editable()} 
                                textAlignLeft
                              />
                            </div>
                          </div>
                        )
                      })
                    }
                  </TableData>
                }
              </SubDetailContainer>
            </GeneralInformationContainer>
          </CardContent>
        </Collapse>
      </Card>
      {
        showCompanyForm ?
          <CompanyForm
            companyData={companyData}
            clearCompanyData={setCompanyData}
            showCompanyModal={setShowCompanyForm}
            onSubmitCompanies={() => {}}
          /> : null
      }
      {
        showUserForm ? 
          <EmailAndTelForm 
            userData={userData}
            listUser={vendorUsers}
            accountGroup={valueForm.accountGroup}
            paymentTypeCheque={valueForm.paymentTypeCheque}
            clearUserData={setUserData}
            showVendorUserModal={setShowUserForm} 
            onSubmitUser={onSubmitVendorUser}
          /> : null
      }
      {
        showBankForm ?
          <BankAccountForm
            bankData={bankData}
            listBank={vendorBanks}
            clearBankData={setBankData}
            showVendorBankModal={setShowBankForm} 
            onSubmitBank={onSubmitVendorBank}
            country={valueForm.country}
          /> : null
      }
      {
        showLoadVendorForm ? 
          <LoadBPForm 
            onLoadBusinessPartnerSuccess={onLoadBusinessPartnerSuccess}
            onLoadBusinessPartnerWarning={onLoadBusinessPartnerWarning}
            showLoadVendorModal={setShowLoadVendorForm}
            vendorCode={valueForm.vendorCode}
            companyCode={valueForm.companyCode}
            purpose={valueForm.purpose}
          /> : null
      }
      <Modal open={showWarningModal}>
        <Header content='Warning!' />
        <Modal.Content>
          <p>{warningMessage}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button 
            color='red' 
            onClick={() => {
              setShowWarningModal(false)
              setWarningMessage('')
            }}>
            <Icon name='remove' /> Close
          </Button>
        </Modal.Actions>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return ({
    address: state.address.address,
    businessPartnerGroups: state.options.businessPartnerGroups,
    bankKeys: state.options.bankKeys,
    companies: state.options.companies,
    countries: state.options.countries,
    currencies: state.options.currencies,
    industries: state.options.industries,
    businessPartners: state.options.businessPartners,
    bankBranch: state.options.bankBranch,
    vendorCompanies: state.vendorMaintenance.vendorCompanies,
  })
}
  
const mapDispatchToProps = {
  getAddress,
  getBankKeys,
  getBPGroups,
  getCompanies,
  getCountry,
  getIndustries,
  getBusinessPartners,
  getBankBranch,
  showConfirmModal,
  getBPCompanies
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInformation)